module.exports = "<div id=\"dashboard-map\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/dashboard/dashboard-map/dashboard-map.component.html
// module id = ../../../../../src/app/dashboard/dashboard-map/dashboard-map.component.html
// module chunks = main